import { ojs, app } from "modular-openscriptjs";

const h = app("h");

export default function Spinner(...args) {
	return h.div(
		{ class: "d-flex justify-content-center align-items-center" },
		h.div(
			{ class: "spinner-border" },
			// h.span({ class: "sr-only" }, "Loading...")
		),
		...args
	);
}

export function SmallSpinner(...args) {
	return h.div(
		{ class: "d-flex justify-content-center align-items-center" },
		h.div(
			{ class: "spinner-border spinner-border-sm" },
		),
		...args
	);
}

export function GlowSpinner(...args) {
	return h.div(
		{ class: "d-flex justify-content-center align-items-center" },
		h.div(
			{ class: "spinner-border spinner-border-glow" },
		),
		...args
	);
}

export function SmallGlowSpinner(...args) {
	return h.div(
		{ class: "d-flex justify-content-center align-items-center" },
		h.div(
			{ class: "spinner-border spinner-border-sm spinner-border-glow" },
		),
		...args
	);
}

ojs(Spinner, SmallSpinner, GlowSpinner, SmallGlowSpinner);
